<template>
    <div>
        <div class="big-title">修改密码</div>

        <van-cell-group v-if="forgetPassword=='0'">
            <van-field label="原密码" type="password" v-model="input.originalPassword" clearable placeholder="请输入原密码" />
            <van-field label="新密码" type="password" v-model="input.newPassword" clearable placeholder="请输入新密码" />
            <van-field label="确认新密码" type="password" v-model="confirmNewPassword" clearable placeholder="请输入新密码" />
        </van-cell-group>
        <van-cell-group v-else>
            <van-field label="新密码" type="password" v-model="input.newPassword" clearable placeholder="请输入新密码" />
            <van-field label="确认新密码" type="password" v-model="confirmNewPassword" clearable placeholder="请输入新密码" />
        </van-cell-group>

        <div class="big-button">
            <van-button type="primary" size="large" :loading="loading" @click="onClick">确定</van-button>
        </div>
    </div>
</template>

<script>
import validate from "@/utils/validator.js";
import customerService from "@/services/customerService.js";
import memberService from "@/services/memberService.js";
import moment from "moment";

export default {
  data() {
    return {
      input: {
        originalPassword: "",
        newPassword: "",
        forgetPassword:false,
        lastChangePasswordTime: "",
      },
      confirmNewPassword: "",
      loading: false
    };
  },
  props: {
    forgetPassword: {
      type: String,
      default: "0"
    },
    dateTime: {
      type: String,
      default: ""
    },
    lastChangePasswordTime: {
      type: String,
      default: ""
    },
    customerId:{
      type: String,
      default: ""
    },
  },
  created(){
    let dateNow = moment().format("YYYY-MM-DD HH:mm");
    if(this.forgetPassword=="1" && this.dateTime && dateNow>this.dateTime)
    {
      this.$router.push({
        name: "errorinfo",
        query: {
          retry: false,
          text: "链接已失效，请重新操作"
        }
      });
      return;
    }
  },
  methods: {
    async onClick() {
      
      var validateRules = [];
      this.input.forgetPassword=(this.forgetPassword=="1");
      //console.log(this.forgetPassword);
      if(this.input.forgetPassword)
      {        
        this.input.lastChangePasswordTime=this.lastChangePasswordTime;
        this.input.customerId=this.customerId;
      }
      else{
        validateRules.push({
          value: this.input.originalPassword,
          name: "原密码",
          rules: [{ rule: "required" }]
        });
      }
      validateRules.push({
          value: this.input.newPassword,
          name: "新密码",
          rules: [{ rule: "required" }]
      });
      let result = validate(validateRules);
      if (!result.success) {
        this.$toast(result.message);
        return;
      }
      if (!this.confirmNewPassword) {
        this.$toast("请再次输入新密码");
        return;
      }
      if (this.input.newPassword !== this.confirmNewPassword) {
        this.$toast("两次输入的密码不一致");
        return;
      }
      const pwdPattern = /^[a-zA-Z0-9_-]{6,12}$/;
      if (!pwdPattern.test(this.input.newPassword)) {
        this.$toast("密码格式不正确");
        return;
      }

      try {
        this.loading = true;
        await customerService.changePasswordAsync(this.input);
        await memberService.customerLogoutAsync();
        this.$router.push("/my");
      } catch (err) {
        return;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss">
.big-title {
  height: 100px;
  line-height: 100px;
  background-color: white;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
.big-button {
  margin-top: 50px;
  padding: 0 20px;
}
</style>